<div
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (mouseenter)="onMouseEnter()"
  (click)="toggleOverlay()">
  <ng-content select="[overlay-trigger]"></ng-content>
</div>

<!-- cdkConnectedOverlayHasBackdrop allows to block horizontal scroll, as it is for three-dots-menu -->
<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPanelClass]="overlayContentClass"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOverlayContentOpen"
  [cdkConnectedOverlayWidth]="matchTriggerWidth ? trigger.elementRef.nativeElement.offsetWidth : null"
  [cdkConnectedOverlayPositions]="position"
  (overlayOutsideClick)="onOutsideClick($event)">
  <div
    #overlayContent
    class="{{overlayContentClass}}"
    [class.w-[100%]]="matchTriggerWidth"
    (click)="onInsideClick()">
    <ng-content select="[overlay-content]"></ng-content>
  </div>
</ng-template>
